/* @ngInject */
function RequestsController ($scope, $rootScope, $q, $timeout, $location, $translate, ModalService, ToastService, TasksService, UserService, ArchivedTasksService, Utils, $state, UdsModalService) {
  const getRequestDetailsDialogController = () => $q.when(import('../../dialogs/request-details/request-details-dialog.controller'))
  const getNewTaskDialogController = () => $q.when(import('../../../workflow/dialogs/new-task/new-task-dialog.controller'))
  const getRequestFormDialogController = () => $q.when(import('../../dialogs/request-form/request-form-dialog.controller'))

  $scope.tabs = {
    openRequests: { status: 'WAITING_RESPONSE', name: 'openRequests', tasks: [], count: 0 },
    taskAdjust: { status: 'WAITING_USER_ADJUST', name: 'taskAdjust', tasks: [], count: 0 },
    rejected: { status: 'REJECTED', name: 'rejectedRequests', tasks: [], count: 0 }
  }

  $scope.selectedTab = $scope.tabs.openRequests
  $scope.selectedSort = {
    name: '',
    order: ''
  }
  $scope.filter = ''
  $scope.currentTop = 10
  $scope.tokensCount = 3
  $scope.skipPagingTo = _skipPagingTo
  $scope.reloadRequestsWhenCloseDialog = _reloadRequestsWhenCloseDialog
  $scope.currentToken = 0
  $scope.pageTitle = ''
  $scope.isLoading = true
  const defaultFilters = {
    createdByMe: false,
    createdByOtherUsers: false,
    archived: false,
    priority: [],
    authorId: null,
    createdAtStart: '',
    createdAtEnd: '',
    deliveryDateStart: '',
    deliveryDateEnd: '',
    withInternalApproval: false
  }
  $scope.filters = angular.copy(defaultFilters)
  $scope.search = ''

  const api = {
    getRequestDetailsDialogController,
    getRequestFormDialogController,
    getNewTaskDialogController,
    _openRequestDetailDialog,
    _insertJustStatusOfWorkflow,
    _keepOnTheSamePage,
    _successGetRequests,
    _reloadRequestsWhenCloseDialog,
    _getRequestsCount,
    _skipPagingTo,
    _initializeDropdowns,
    _openRequestForm,
    _onSuccessRequestForm,
    _setHeader,
    _showFillFormDialog,
    _openArchivedTasks,
    _onFilter,
    _onSearch,
    _setFilter,
    _formatCardItems
  }
  this.getApi = () => api

  activate()

  function activate () {
    $rootScope.getUser().then(user => {
      if ($rootScope.isUserSysAdminAdminDesigner(user)) {
        $state.go('workflow')
        return
      }

      $scope.isConsultant = !!user?.isGroupOwner
      $scope.isUser = $rootScope.isUser(user)
      $scope.isGroupManager = $rootScope.oUser.isGroupManager

      const params = $location.search()

      $scope.isInReactNativeWebView = Utils.isInReactNativeWebView()

      if (angular.equals($scope.filters, defaultFilters)) {
        api._setHeader()
      }

      $rootScope.getUser().then((user) => {
        const isNotUserSysAdminAdmin = !$rootScope.isUserSysAdminAdmin(user)
        if (params.request) {
          api._openRequestDetailDialog(params.request)
        }

        if (params.createRequest && isNotUserSysAdminAdmin) {
          api._openRequestForm(api._onSuccessRequestForm)
        }

        api._skipPagingTo(0)
      }).catch(angular.noop)
    })
  }

  $scope.showFillFormDialog = api._showFillFormDialog
  $scope.openArchivedTasks = api._openArchivedTasks

  $scope.sortListClick = function (field) {
    if ($scope.selectedSort.name === field) {
      if ($scope.selectedSort.order === 'asc') {
        $scope.selectedSort.order = 'desc'
      } else if ($scope.selectedSort.order === 'desc') {
        $scope.selectedSort.order = ''
        $scope.selectedSort.name = ''
      }
    } else {
      $scope.selectedSort.name = field
      $scope.selectedSort.order = 'asc'
    }
    activate()
  }

  const deregisterReloadRequests = $rootScope.$on('workflow.reload-requests', () => {
    api._skipPagingTo(0)
  })

  $scope.$on('$destroy', () => {
    deregisterReloadRequests()
  })

  $scope.changeSelectedTab = function (tab) {
    $scope.isLoading = true
    $scope.selectedTab = tab
    $scope.indexPage = 0

    api._skipPagingTo(0)
  }

  function _openArchivedTasks () {
    ArchivedTasksService.open()
  }

  $scope.handleFilterClick = function (status) {
    if ($scope.filter === status) {
      $scope.filter = ''
    } else {
      $scope.filter = status
    }
    activate()
  }

  $scope.closeRequestsPage = function () {
    $scope.$parent.$parent.preventSocketReload = true
    $scope.$emit('workflow.closeRequests')
  }

  $scope.changeSortMobile = function (field, order) {
    $scope.selectedSort.order = order || 'desc'
    $scope.selectedSort.name = field
    activate()
  }

  $scope.handleBackClick = function () {
    const params = $location.search()

    if (params.from) {
      $location.url(params.from)
    } else {
      $state.go('workflow.home')
    }
  }

  function _skipPagingTo (token) {
    const params = {
      $sort: $scope.selectedSort.name,
      $order: $scope.selectedSort.order,
      status: $scope.filter,
      $top: $scope.currentTop,
      $skip: token * $scope.currentTop,
      filters: $scope.filters,
      search: $scope.search
    }

    if (params.filters.createdAtRange) {
      delete params.filters.createdAtRange
    }

    if (params.filters.deliveryDateRange) {
      delete params.filters.deliveryDateRange
    }

    $scope.currentToken = token

    if ($scope.filter === 'ADJUSTMENTS') {
      params.status = 'WAITING_USER_ADJUST'
    }

    if ($rootScope.isUser()) {
      $scope.isLoading = true
      TasksService.getRequests(params)
        .then(api._successGetRequests)
        .finally(() => {
          $scope.isLoading = false
        })
    } else {
      api._getRequestsCount().then(requestsCount => {
        const rejected = requestsCount.find(row => row.status === 'REJECTED')
        const openRequests = requestsCount.find(row => row.status === 'WAITING_RESPONSE')
        const adjusts = requestsCount.find(row => row.status === 'WAITING_USER_ADJUST')

        $scope.tabs.openRequests.count = openRequests ? openRequests.count : 0
        $scope.tabs.taskAdjust.count = adjusts ? adjusts.count : 0
        $scope.tabs.rejected.count = rejected ? rejected.count : 0

        TasksService.getRequestsByStatus($scope.selectedTab.status, { top: params.$top, skip: params.$skip }, { sort: params.$sort, order: params.$order })
          .then(response => api._keepOnTheSamePage(response, requestsCount, token))
      })
    }
  }

  /**
   *  @typedef {Array} ArrayStatus
   *  @param {Array} cardItems - all status in array for workflow
   *
   *  @return {ArrayStatus}
   *  return just status array of workflow, remove status not used
   */
  function _insertJustStatusOfWorkflow (cardItems) {
    return cardItems.reduce((acc, item) => {
      if (item.name === 'WAITING_USER_ADJUST' || item.name === 'WAITING_ADM_ADJUST') {
        const adjustmentsItem = acc.find(item => item.name === 'ADJUSTMENTS')

        if (adjustmentsItem) {
          adjustmentsItem.value += parseInt(item.value)
        } else {
          acc.push({ name: 'ADJUSTMENTS', value: parseInt(item.value) })
        }

        return acc
      }

      if (item.name === 'REJECTED') {
        return acc
      }

      acc.push({ ...item, value: parseInt(item.value) })

      return acc
    }, [])
  }

  function _keepOnTheSamePage (response, requestsCount, token) {
    $scope.isLoading = false

    const selectedTabType = $scope.selectedTab.status
    $scope.indexToken = token
    api._initializeDropdowns()

    if (!response.rows.length && !token) {
      $scope.selectedTab.tasks = []
      $scope.selectedTab.count = 0
      $scope.taskCount = 0
      return
    }

    if (response.rows.length) {
      const selectedTabRequestsCount = requestsCount.find(row => row.status === selectedTabType)

      $scope.selectedTab.tasks = response.rows
      $scope.taskCount = selectedTabRequestsCount?.count

      if (!$scope.selectedTab.count) {
        $scope.selectedTab.count = $scope.taskCount
      }
    } else if (token) {
      api._skipPagingTo(token - 1)
    }
  }

  function _successGetRequests (requests) {
    $scope.taskCount = requests.count
    $scope.tasksCountText = $translate.instant('allRequests', { count: $scope.taskCount })
    if (requests.stats) {
      $scope.cardItems = api._formatCardItems(requests.stats)
    }

    $scope.requests = {
      count: requests.count,
      rows: requests.rows
    }

    api._initializeDropdowns()
  }

  function _formatCardItems (stats) {
    const cardItems = []
    cardItems.push({
      name: 'WAITING_RESPONSE',
      value: stats.waitingResponse
    }, {
      name: 'INBOX',
      value: stats.inbox
    }, {
      name: 'PROGRESS',
      value: stats.progress
    }, {
      name: 'WAITING_USER_ADJUST',
      value: stats.adjust
    }, {
      name: 'REVIEW',
      value: stats.review
    }, {
      name: 'DONE',
      value: stats.done
    }, {
      name: 'REJECTED',
      value: stats.rejected
    })

    if ($scope.isConsultant || $scope.isGroupManager) {
      cardItems.splice(0, 0, {
        name: 'WAITING_PRE_APPROVAL',
        value: stats.waitingMyApproval
      })
    }

    return cardItems
  }

  function _initializeDropdowns () {
    $timeout(() => {
      $('.sort-button-dropdown').dropdown({
        showOnFocus: false
      })
    }, 100, false)
  }

  function _openRequestDetailDialog (id) {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        },
        onClose: api._reloadRequestsWhenCloseDialog
      })
      modal.open()
    })
  }

  function _reloadRequestsWhenCloseDialog ({ wasUpdated }) {
    if (wasUpdated) {
      api._skipPagingTo($scope.currentToken)
    }
  }

  function _getRequestsCount () {
    return TasksService.getRequestsCountByStatus()
  }

  $scope.goToForms = function () {
    $state.go('workflow.briefings')
  }

  function _showFillFormDialog () {
    $location.search({ createRequest: true })

    api._openRequestForm(updateList => {
      if (updateList) {
        api._skipPagingTo(0)
      }
    })
  }

  function _openRequestForm (onDialogClose) {
    api.getRequestFormDialogController().then(({ RequestFormDialogController }) => {
      ModalService.showModal({
        templateId: 'requestForm.html',
        templateUrl: '/workflow/dialogs/request-form/request-form-dialog.html?$$REVISION$$',
        controller: RequestFormDialogController,
        destroyable: true,
        observeChanges: true
      }).then(prop => {
        $location.search({ createRequest: null })
        onDialogClose(prop)
      })
    })
  }

  function _onSuccessRequestForm (created) {
    if (created) {
      ToastService.defaultSuccessToast()
    }
  }

  function _setHeader () {
    $scope.pageTitle = $translate.instant('requests')

    const exhibitDefaultValue = {
      label: $translate.instant('actives'),
      value: false,
      icon: 'success',
      active: true,
      disabled: false
    }

    const archivedFilter = {
      label: $translate.instant('archivedPlural'),
      value: true,
      icon: 'archive',
      active: false,
      disabled: false
    }

    const filterOptions = [
      exhibitDefaultValue,
      archivedFilter
    ]

    const isArchived = {
      name: 'archived',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: exhibitDefaultValue,
      props: {
        label: $translate.instant('exhibit'),
        multiple: false,
        switchMode: true,
        udsDisabled: false,
        options: filterOptions
      }
    }

    const priority = $scope.isUser && $scope.isConsultant ? {
      name: 'priority',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: [],
      props: {
        label: $translate.instant('priorityFilter'),
        multiple: true,
        switchMode: false,
        udsDisabled: false,
        options: [
          {
            label: $translate.instant('LOW'),
            value: 'LOW',
            icon: 'chevron-down',
            active: false,
            disabled: false,
            color: 'feedbackColorGreenPure'
          },
          {
            label: $translate.instant('MEDIUM'),
            value: 'MEDIUM',
            icon: 'minus',
            active: false,
            disabled: false,
            color: 'feedbackColorOrangePure'
          },
          {
            label: $translate.instant('HIGH'),
            value: 'HIGH',
            icon: 'chevron-up',
            active: false,
            disabled: false,
            color: 'feedbackColorRedPure'
          },
          {
            label: $translate.instant('URGENT'),
            value: 'URGENT',
            icon: 'chevron-up-double',
            active: false,
            disabled: false,
            color: 'feedbackColorRedPure'
          }
        ]
      }
    } : null

    const applicant = $scope.isConsultant ? {
      name: 'authorId',
      type: 'INPUT_SELECT',
      grouped: false,
      defaultValue: null,
      props: {
        label: $translate.instant('applicant'),
        placeholder: $translate.instant('selectPlaceholder'),
        emptyMsg: $translate.instant('noResults'),
        type: 'text',
        hasMoreOptions: false,
        udsDisabled: false,
        pricing: false,
        pricingTooltip: '',
        pricingTooltipPosition: 'top',
        options: []
      },
      loadData: async (searchTerm, top, skip) => {
        return UserService.getOwnedUsers({ $top: top, $skip: skip, search: searchTerm })
      }
    } : null

    const createdAtRange = {
      name: 'createdAtRange',
      type: 'DATE_RANGE_PICKER',
      grouped: true,
      defaultValue: $scope.filters.createdAtStart ? {
        start: $scope.filters.createdAtStart,
        end: $scope.filters.createdAtEnd
      } : '',
      props: {
        locale: $rootScope.oUser.locale,
        label: $translate.instant('createdAt'),
        firstDayOfWeek: '1',
        direction: 'right'
      }
    }

    const deliveryDateRange = {
      name: 'deliveryDateRange',
      type: 'DATE_RANGE_PICKER',
      grouped: true,
      defaultValue: $scope.filters.deliveryDateStart ? {
        start: $scope.filters.deliveryDateStart,
        end: $scope.filters.deliveryDateEnd
      } : '',
      props: {
        locale: $rootScope.oUser.locale,
        label: $translate.instant('deliveryDate'),
        firstDayOfWeek: '1',
        direction: 'right'
      }
    }

    const filters = [
      isArchived,
      priority,
      applicant,
      createdAtRange,
      deliveryDateRange
    ].filter(Boolean)

    const rightButtons = $rootScope.isDesktop ? [
      {
        type: 'button',
        btnType: 'primary',
        label: $translate.instant('newRequest'),
        icon: 'plus',
        onClick: api._showFillFormDialog
      }
    ] : [
      {
        type: 'icon',
        icon: 'plus',
        onClick: api._showFillFormDialog
      }, {
        type: 'dropdown',
        btnType: 'icon',
        icon: 'more',
        options: [{
          icon: 'archive',
          label: $translate.instant('archivedPlural'),
          onClick: api._openArchivedTasks
        }]
      }
    ]

    const leftButtons = []

    if ($rootScope.isDesktop && $scope.isConsultant) {
      leftButtons.push(
        {
          type: 'button',
          btnType: 'tertiary',
          label: $translate.instant('createdByMe'),
          onClick: () => api._setFilter('createdByMe')
        },
        {
          type: 'button',
          btnType: 'tertiary',
          label: $translate.instant('fromAnotherUsers'),
          onClick: () => api._setFilter('createdByOtherUsers')
        }
      )

      $rootScope.reloadCompanyConfigurations().then(() => {
        if ($rootScope.oUserCompanyConfigurations.ENABLE_INTERNAL_APPROVAL_CONSULTANTS) {
          leftButtons.push({
            type: 'button',
            btnType: 'tertiary',
            label: $translate.instant('withInternalApproval'),
            onClick: () => api._setFilter('withInternalApproval')
          })
        }
      })
    }

    $scope.headerToolbar = $rootScope.isDesktop ? {
      rightButtons,
      leftButtons,
      search: {
        filters,
        onFilter: api._onFilter,
        onSearch: api._onSearch
      }
    } : {
      rightButtons
    }
  }

  function _setFilter (filter) {
    if (filter === 'createdByMe') {
      if ($scope.filters.applicant) {
        $scope.filters.applicant = null
      }
      $scope.filters.createdByMe = !$scope.filters.createdByMe
      $scope.filters.createdByOtherUsers = false
      api._skipPagingTo(0)
    } else if (filter === 'withInternalApproval') {
      $scope.filters.withInternalApproval = !$scope.filters.withInternalApproval
      api._skipPagingTo(0)
    } else if (filter === 'createdByOtherUsers') {
      if ($scope.filters.applicant) {
        $scope.filters.applicant = null
      }
      $scope.filters.createdByMe = false
      $scope.filters.createdByOtherUsers = !$scope.filters.createdByOtherUsers
      api._skipPagingTo(0)
    }
  }

  function _onFilter (filters, hasPreFilters) {
    if (hasPreFilters) {
      return
    }

    if (filters.applicant) {
      if (filters.createdByMe || filters.createdByOtherUsers) {
        filters.createdByMe = false
        filters.createdByOtherUsers = false
      }
    }

    $scope.filters = filters
    api._skipPagingTo(0)
  }

  function _onSearch (search) {
    $scope.search = search
    api._skipPagingTo(0)
  }
}

export { RequestsController }
